import { browser } from "$app/environment";

let isScrollTriggerRegistered = false;

export async function registerScrollTrigger() {
  if (!browser) {
    return null;
  }

  const [{ gsap }, { ScrollTrigger }] = await Promise.all([
    import("gsap"),
    import("gsap/ScrollTrigger"),
  ]);

  if (!isScrollTriggerRegistered) {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    isScrollTriggerRegistered = true;
  }

  if (window.matchMedia("(min-width: 64rem)").matches) {
    // Separate section setup tasks so imports do not release one long DOM-work burst.
    await new Promise<void>((resolve) => window.setTimeout(resolve, 0));
  }

  return { gsap, ScrollTrigger };
}

let initialRefreshPromise: Promise<void> | undefined;
let refreshPromise: Promise<void> | undefined;

export function refreshScrollTriggersAfterFonts() {
  if (!browser) return Promise.resolve();
  if (initialRefreshPromise) return initialRefreshPromise;

  initialRefreshPromise = refreshScrollTriggers();

  return initialRefreshPromise;
}

export function refreshScrollTriggers() {
  if (!browser) return Promise.resolve();
  if (refreshPromise) return refreshPromise;
  refreshPromise = (async () => {
    const runtime = await registerScrollTrigger();
    if (!runtime) return;
    await document.fonts.ready;
    if (
      document.querySelector(".site-preloader") &&
      document.documentElement.dataset.preloaderComplete !== "true"
    ) {
      await new Promise<void>((resolve) =>
        window.addEventListener("site-preloader-complete", () => resolve(), {
          once: true,
        }),
      );
    }
    await new Promise<void>(resolve => requestAnimationFrame(() => resolve()));
    runtime.ScrollTrigger.sort();
    runtime.ScrollTrigger.refresh();
  })().finally(() => { refreshPromise = undefined; });
  return refreshPromise;
}
